import { RHFTextField } from "../../../components/Forms";
import { notBlank } from "../../../components/Forms/validations";
import { useMsg } from "../../../components/Msg/Msg";
import { sessionsMessages } from "../messages";
import { FormStepCard } from "./FormStepCard";
import { SESSION_FIELDS } from "./constants";

export const MotivationStep = ({ step, stepper, data }) => {
  const msg = useMsg({ dict: sessionsMessages });
  const field = step.fieldDefMap[SESSION_FIELDS.MOTIVATION];

  return (
    <FormStepCard {...{ step, stepper, data }}>
      <RHFTextField
        name={SESSION_FIELDS.MOTIVATION}
        rules={{
          required: "Required",
          validate: { ...(field.validate ?? { notBlank: notBlank() }) },
        }}
        placeholder={msg("sessions.steps.textareastep.placeholder", {
          textAreaName: SESSION_FIELDS.MOTIVATION,
        })}
        autoFocus
        size="small"
        hiddenLabel
        multiline
        rows={4}
        sx={{ my: 4 }}
        fullWidth
      />
    </FormStepCard>
  );
};
